import MicroModal from "micromodal";
function microModal(): void {
  MicroModal.init({
    disableScroll: true,
    disableFocus: true,
  });
}

export { microModal };
